import React from 'react'
import { useField, FieldHookConfig } from 'formik'
import TextField, { TextFieldProps } from '@mui/material/TextField'

type Props = FieldHookConfig<string> & TextFieldProps & { shrink?: boolean; endAdornment?: React.ReactNode }

const TextFormField: React.FC<Props> = (props) => {
  const [field, meta] = useField(props)
  const errorText = meta.error && meta.touched ? meta.error : ''
  const { endAdornment, shrink, ...rest } = props

  return (
    <TextField
      fullWidth
      {...rest}
      disabled={props.disabled}
      variant="filled"
      helperText={errorText ? errorText : props.helperText}
      error={!!errorText}
      InputProps={{
        endAdornment: endAdornment,
        sx: { pt: props.multiline ? '30px' : '6px' }
      }}
      InputLabelProps={{
        shrink: shrink,
        sx: {
          transform: 'translate(12px, 20px) scale(1)',
          '&.MuiInputLabel-shrink': {
            maxWidth: 'calc(133% - 55px)',
            transform: 'translate(12px, 7px) scale(0.9)'
          }
        }
      }}
      {...field}
    />
  )
}

export default TextFormField
